import { modalForm } from './modules/modal-form.js';
import { wowAnimations } from './modules/wow-animations.js';
import { countStart } from './modules/counters.js';
import { videoPlay } from './modules/video.js';
import { footerNav } from './modules/footer-nav.js';

document.addEventListener( 'DOMContentLoaded', function() {
    modalForm();
    wowAnimations();
    countStart();
    videoPlay();
    footerNav();
  }
);
